import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <p>
            Welcome to my curated collection of Minecraft modpacks! Dive into a treasure trove of adventures with links to the playlists of some of my favorite packs. While this gallery showcases a selection of handpicked gems, it's just the tip of the iceberg in terms of the diverse experiences awaiting exploration. So, grab your pickaxe and venture forth into a world of endless possibilities!
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
